import {
  IInternalTicketActionBody,
  IInternalTicketCreateBody,
} from '../../../interfaces/newStudent/ticket.interface';

export const buildCreateTicketFormData = (
  body: IInternalTicketCreateBody,
  files: File[],
): FormData => {
  const formData = new FormData();
  formData.append('title', body.title ?? '');
  formData.append('serviceId', String(body.serviceId ?? 0));
  formData.append('description', body.description ?? '');
  files.forEach((file) => formData.append('files[]', file));
  return formData;
};

export const buildTicketActionFormData = (
  body: IInternalTicketActionBody,
  files: File[],
): FormData => {
  const formData = new FormData();
  formData.append('description', body.description);
  files.forEach((file) => formData.append('files[]', file));
  return formData;
};
